import $ from 'jquery';
import heightAnimate from '../../scripts/util/animate/heightAnimate';

export default class {
	constructor(options) {
		const defaults = {
			el: '.js-orders',

			dom: {
				item: '.js-orders-item',
				order: '.js-order',
				info: '.js-order-info',
				status: '.js-order-status',
				content: '.js-order-content',
				actions: '.js-order-actions',
				revoke: '.js-order-revoke'
			},

			classes: {
				order: {
					state: {
						opened: 'order_state_opened'
					}
				}
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
	}

	getDom() {
		this.$item = this.$el.find(this.options.dom.item);
		this.$order = this.$el.find(this.options.dom.order);
		this.$info = this.$el.find(this.options.dom.info);
		this.$status = this.$el.find(this.options.dom.status);
		this.$content = this.$el.find(this.options.dom.content);
		this.$actions = this.$el.find(this.options.dom.actions);
		this.$revoke = this.$el.find(this.options.dom.revoke);
	}

	onClick = e => {
		const $target = $(e.target);
		const $item = $target.closest(this.$item);
		const $order = $item.find(this.options.dom.order);
		const $items = $item.siblings();
		const $content = $item.find(this.options.dom.content);
		const $openOrder = this.$el.find(`.${this.options.classes.order.state.opened}`);
		const delay = $openOrder.length ? 0.4 : 0;

		$items.each(item => {
			const $el = $items.eq(item);
			const $currentOrder = $el.find(this.options.dom.order);
			const $currentContent = $currentOrder.find(this.options.dom.content);

			if ($currentOrder.hasClass(this.options.classes.order.state.opened)) {
				$currentOrder.removeClass(this.options.classes.order.state.opened);
				heightAnimate($currentContent, 0.4, 'close');
			}
		});

		if (!$order.hasClass(this.options.classes.order.state.opened)) {
			heightAnimate($content, 0.4, 'open', delay);
			setTimeout(() => {
				$order.toggleClass(this.options.classes.order.state.opened);
			}, delay * 1000);
		} else {
			heightAnimate($content, 0.4, 'close');
			$order.toggleClass(this.options.classes.order.state.opened);
		}
	}

	revokeOrder = e => {
		const $target = $(e.target);
		const $order = $target.closest(this.options.dom.order);
		const $status = $order.find(this.options.dom.status);
		const $actions = $order.find(this.options.dom.actions);

		$status.text('Отменён');
		$actions.remove();
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.$info.on('click', this.onClick);
			this.$revoke.on('click', this.revokeOrder);
		}
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/orders/orders.js
 **/